var map = {
	"./css.svg": "ca83",
	"./express.svg": "04d2",
	"./fireworks-2023.png": "72ad",
	"./fireworks-2023_box.png": "eddf",
	"./firts-portfolio.png": "2ebc",
	"./firts-portfolio_box.png": "6535",
	"./herta-kuru.png": "3e5b",
	"./herta-kuru_box.png": "a7be",
	"./html.svg": "a376",
	"./javascript.svg": "3c64",
	"./kebelet-iphone.png": "cfe4",
	"./kebelet-iphone_box.png": "08ae",
	"./kliniku.png": "7042",
	"./kliniku_box.png": "d3fa",
	"./laptop.svg": "4995",
	"./logo-outline-white.svg": "37ea",
	"./logo.svg": "9b19",
	"./logoName.svg": "d02b",
	"./mongodb.svg": "99e0",
	"./node.svg": "93a0",
	"./phone.svg": "001e",
	"./profile.svg": "b855",
	"./react.svg": "b2e9",
	"./sass.svg": "21f5",
	"./snake.png": "a80b",
	"./snake_box.png": "5689",
	"./statued.png": "a433",
	"./statued_box.png": "0741",
	"./terminal-portfolio.png": "d236",
	"./terminal-portfolio_box.png": "9462",
	"./vue.svg": "038d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";